module.exports = __webpack_public_path__ + "static/media/cookedmonstermeat.92e50dbb.webp";